import { render, staticRenderFns } from "./DeleteExchangeRate.vue?vue&type=template&id=6790cd5a"
import script from "./DeleteExchangeRate.vue?vue&type=script&lang=js"
export * from "./DeleteExchangeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports